export const displayItinerarySelector = ({displayItinerary}) => displayItinerary